import React from 'react';
import { PvInput } from 'styles/CustomComponents';
import { addColonIntoTime} from "../../util/SearchUtil";

export const PvClockInput = (props) => (
  <PvInput style={{minWidth: '4.5em'}}
           value={props.value}
           onChange={(e) => props.onChangeFn(addColonIntoTime(e.target.value))}
           placeholder={'HH:mm'} />
);




// WEBPACK FOOTER //
// ./src/components/form/PvClockInput.jsx